export const getDeviceUser = () => window.navigator.userAgent;
